<template>
    <div class="x_box A4">
        <div class="x_body">
            <ReportHeader/>
            <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
            <div class="print-header">
                <h6 class="text-center font-m">វិក្កយបត្រ</h6>
                <h6 class="text-center" style="font-weight: 600;">INVOICE</h6>
            </div>
            <div class="row" style="margin-bottom: 20px">
                <div class="col-sm-12">
                    <table class="table-sm" style="border: 1px solid #000; width: 100%;">
                        <thead>
                            <tr style="border-bottom: 1px solid #000;">
                                <th colspan="3">អតិថិជន/Customer Name</th>
                                <th colspan="3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="vertical-align: top;">
                                <td style="width: 130px;">អតិថិជន<br>Name</td>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top" style="border-right: 1px solid #000;">{{customer.Name}}<br>{{ customer.NameEng }}</td>
                                <td style="width: 105px;">លេខវិក្កយបត្រ<br>INVOICE NO</td>
                                <td style="width: 15px;">:</td>
                                <td style="width: 180px;">{{invoice.Num}}</td>
                            </tr>
                            <tr style="vertical-align: top;">
                                <td>អាស័យដ្ឋាន<br>ADDRESS</td>
                                <td>:</td>
                                <td style="border-right: 1px solid #000;">{{customer.Address}}</td>
                                <td>កាលបរិច្ឆេទ<br>DATE</td>
                                <td>:</td>
                                <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                            </tr>
                            <tr style="v-top">
                                <td>លេខទូរស័ព្ទ</td>
                                <td>:</td>
                                <td style="border-right: 1px solid #000;">{{customer.Phone}}</td>
                                <td>អត្រាប្ដូរប្រាក់</td>
                                <td>:</td>
                                <td>{{invoice.ExchangeRate}}</td>
                            </tr>
                            <tr class="v-top">
                                <td></td>
                                <td></td>
                                <td style="border-right: 1px solid #000;"></td>
                                <td>ផុតកំណត់<br>DUE DATE</td>
                                <td>:</td>
                                <td>{{$format(invoice.DueDate, 'DD/MM/YYYY')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" style="min-height: 750px;">
                <div class="col-sm-12">
                    <table class="table-bordered table-sm" style="width: 100%; border: none;">
                        <thead style="background: #b3cce6">
                            <tr class="text-center">
                                <th style="width: 50px;">ល.រ <br> NO</th>
                                <th>បរិយាយមុខទំនិញ ឬសេវាកម្ម <br> DESCRIPTION OF GOODS OR SERVICES </th>
                                <th style="width: 80px;">បរិមាណ <br> QTY</th>
                                <th style="width: 110px;">តម្លៃឯកតា <br> PRICE</th>
                                <th style="width: 110px;">ថ្លៃទំនិញ <br> AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret,index) in lines" :key="ret.Id">
                                <td class="text-center v-mid">{{index+1}}</td>
                                <td style="height: 53px;">{{ret.ItemName}}<br>{{ret.ItemNameEn}}</td>
                                <td class="text-center v-mid">{{ret.Quantity}} {{ret.UomName}}</td>
                                <td class="text-right v-mid">{{$money(ret.Price + ret.TaxAmount)}}</td>
                                <td class="text-right v-mid">{{$money(ret.SubTotal + (ret.TaxAmount*ret.Quantity))}}</td>
                            </tr>
                            <tr v-for="index in (10 - lines.length)" :key="index">
                                <td class="text-center v-mid">{{ lines.length + index }}</td>
                                <td style="height: 53px;"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2" rowspan="2" style="border: none !important;"></td>
                                <td class="text-right" colspan="2" style="border: none !important;">សរុបរួមទាំងអាករ (ដុល្លារ)<br>TOTAL (Incl. VAT) USD</td>
                                <td class="text-right" style="vertical-align: middle;">{{$money(invoice.TotalAmount)}}</td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2" style="border: none !important;">សរុបរួមទាំងអាករ (រៀល)<br>TOTAL (Incl. VAT) Riel</td>
                                <td class="text-right">{{$number(invoice.TotalAmount * invoice.ExchangeRate)}}</td>
                            </tr>
                            <tr>
                                <td colspan="2" rowspan="2" style="border: none !important;"></td>
                                <td class="text-right" colspan="2" style="border: none !important;">បញ្ចុះតម្លៃ<br>Discount</td>
                                <td class="text-right v-mid">{{$money(invoice.Discount)}}</td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2" style="border: none !important;">សរុបប្រាក់ត្រូវបង់ (ដុល្លារ)<br>Amount due (USD)</td>
                                <td class="text-right v-mid">{{$money(invoice.Balance)}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="footer" style="padding: 0 15px;">
            <div style="margin: 0 100px;">
                <div style="display: flex; justify-content: space-between">
                <div>
                    <div style="margin-left: 20px">ហត្តលេខា​ និងឈ្មោះអ្នកទិញ</div>
                    <div style="margin-left: 10px">Customer's Signature & Name</div>
                    <div style="border-bottom: 1px dashed #5d5c5c; width: 200px; height: 80px;"></div>
                </div>
                <div class="text-center">
                    <div>ហត្តលេខា​និងឈ្មោះអ្នកលក់</div>
                    <div>Seller's Signature & Name</div>
                    <div style="border-bottom: 1px dashed #5d5c5c; width: 200px; height: 80px;"></div>
                </div>
            </div>
            </div>
            <br>
            <div>
                <div>សម្គាល់៖​ ច្បាប់ដើមសម្រាប់អ្នកទិញ ច្បាប់ចម្លងសម្រាប់អ្នកលក់</div>
                <div>Note: Original Invoice for customer, Copies Invoice for seller.</div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Sale } from '../../../shared/models/model';
    import ReportHeader from '../../Components/ReportHeader';
    export default {
        components: { ReportHeader },
        data() {
            return {
                customer: {},
                Bank: {},
                invoice: {},
                lines: [],
            }
        },
        created() {
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            findById(){
                let id = this.$route.params.id;
                if(id != undefined && id != null && id != ''){
                    let loading = this.$loading.show();
                    let req = {
                        CompanyId: this.$store.state.company.Id,
                        Id: id
                    };
                    Sale.findInvoicePreview(req).then(res => {
                        this.invoice = res.Json.Header;
                        this.lines = res.Json.Lines;
                        this.customer = res.Json.Customer;
                        this.Bank = res.Json.Bank;
                    }).finally(() => { loading.hide(); });
                }
            }
        },
        computed: {
            deliveryDate(){
                var res = "N/A";
                if(this.invoice.DocSource == 'Manual' && this.invoice.DeliveryNote != null){
                    res = this.$format(this.invoice.DeliveryNote.OutDateAt, 'DD/MM/YYYY');
                }else res = this.invoice.DeliveryDateNote;
                return res;
            },
            deliveryNo(){
                var res = "N/A";
                if(this.invoice.DocSource == 'Manual' && this.invoice.DeliveryNote != null){
                    res = this.invoice.DeliveryNote.Num;
                }

                return res;
            }
        }
    }
</script>
<style scoped>
    .table-bordered th, .table-bordered td {
        border: 1px solid black;
    }
    @media print{
        .table-bordered th, .table-bordered td {
            border: 1px solid black !important;
        }
    }
</style>
